import { render, staticRenderFns, recyclableRender, components } from "./homePage.vue?vue&type=template&id=1b7bfbe4&scoped=true&"
var renderjs
import script from "./homePage.vue?vue&type=script&lang=js&"
export * from "./homePage.vue?vue&type=script&lang=js&"
import style0 from "./homePage.vue?vue&type=style&index=0&id=1b7bfbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bfbe4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/index/homePage.vue"
export default component.exports